@if (!countries || !countries.length ) {
<p class="mat-body-1">
  {{ "ONSIP_I18N.AVAILABLE_IN_ALL_COUNTRIES" | translate }}
</p>
} @else {
<onsip-list-picker-view
  [itemNamePlural]="'ONSIP_I18N.COUNTRIES' | translate"
  [itemList]="countryListItems"
></onsip-list-picker-view>
}
